import { useEffect } from 'react';

import { Button } from '@mui/material';

import { useSimpleEvent } from 'analytics/appInsights';
import { ErrorPage } from 'components/feedback/state/errors/ErrorPage';
import { LoadingPage } from 'components/feedback/state/loading/LoadingPage';
import { devLog } from 'utils/dev-utils';

import { useReAuthenticate } from './hooks/useReAuthenticate';
import { useResetAuthenticateCount } from './hooks/useRedirectWithLimit';

export function Processing() {
  useSimpleEventAuthenticationStates('Processing');

  return <LoadingPage loading />;
}

export function LoggingIn() {
  useSimpleEventAuthenticationStates('LoggingIn');

  return <LoadingPage loading />;
}

export function LoggedIn() {
  useSimpleEventAuthenticationStates('LoggedIn');
  useResetAuthenticateCount();

  return <LoadingPage loading />;
}

export function SessionLost() {
  useSimpleEventAuthenticationStates('SessionLost');

  const { shouldRedirect, redirect } = useReAuthenticate();

  if (shouldRedirect) {
    return <LoadingPage loading />;
  }

  return (
    <ErrorPage title='Session Lost' description='Something went wrong'>
      <Button onClick={redirect} variant='contained' color='primary'>
        Try again
      </Button>
    </ErrorPage>
  );
}

export function NotAuthorized() {
  useSimpleEventAuthenticationStates('NotAuthorized');

  return (
    <ErrorPage title='Not authorized' description="You are logged in, but you're not allowed to use this resource" />
  );
}

export function NotAuthenticated() {
  useSimpleEventAuthenticationStates('NotAuthenticated');

  const { shouldRedirect, redirect } = useReAuthenticate();

  if (shouldRedirect) {
    return <LoadingPage loading />;
  }

  return (
    <ErrorPage title='Authentication error' description='Something went wrong while authenticating'>
      <Button onClick={redirect} variant='contained' color='primary'>
        Try again
      </Button>
    </ErrorPage>
  );
}

export function useSimpleEventAuthenticationStates(event: string) {
  const trackSimpleEvent = useSimpleEvent(event);

  useEffect(() => {
    devLog('useSimpleEventAuthenticationStates', event);
    trackSimpleEvent();
  }, [event, trackSimpleEvent]);
}
